export default __webpack_public_path__ + "static/media/mascota.09e4989c.gif";